import { Component } from '@angular/core';
import { VariableService } from '../services/sharedVariables';

@Component({
  selector:'footerweb',
  templateUrl:'../views/page-sections/footerweb.html'
})
export class FooterWebComponent{
  public  title:string;
  public logged:boolean;

  constructor(
    private sharedVariables: VariableService
  )
  {
    this.title = "Footer component";
  }

  ngOnInit()
  {
    console.log("footer initialized");
    this.validSession();
  }

  validSession()
  {
    if(this.sharedVariables.validSession()){
      this.logged = true;
    }
    else
      this.logged = false;
  }

}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/footer.component.ts